// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3GHf0","productName":"Table_productName__2soTT"};